export default __webpack_public_path__ + "static/media/1.3dd3ca5a.jpeg";